module.exports = __webpack_public_path__ + "static/img/banner_news_01.cc70430.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/news/banner_news_01.png
// module id = /MN0
// module chunks = 10